/**
 * Shared node/gate geometry for the checklist drawing board and every
 * add-to-canvas path (drag-drop, manual toolbar, AI Line, external writers).
 *
 * Historically these lived only inside `ChecklistDrawingBoard.tsx`, which
 * meant writers that created checklists from outside the board (BoardExplorer,
 * QuickCreate, AI generation) had no way to compute a non-overlapping
 * position and defaulted to (0, 0). Centralising them here lets
 * `canvasPlacementService.findEmptyCanvasSlot` produce the same slot
 * arrangement the board itself would.
 */
export const NODE_WIDTH = 330
export const NODE_BODY_HEIGHT = 64
export const NODE_CAP_RADIUS = 23
export const NODE_CAP_DIAMETER = 46
export const NODE_HEIGHT = 64 + 2 * 23 // 110: bounding-box height including caps
export const GATE_DIAMETER = 96
export const GATE_CENTER_PILL_W = 62
export const GATE_CENTER_PILL_H = 24
export const NODE_GAP = 44
export const GRID_ROW_GAP = 72
export const GRID_LINE_HEIGHT = 72
export const BOARD_PADDING = 50
export const MAX_CHECKLIST_GRID_COLUMNS = 7
export const MAX_PARALLEL_ROW_ITEMS = 7

/** 8 px slack matches the existing `overlapsNode` check on the drawing board. */
export const NODE_OVERLAP_SLACK = 8

export const isGateNodeKind = (nodeKind: string | null | undefined): boolean =>
  nodeKind === 'GATE_AND' || nodeKind === 'GATE_OR'

export const dimensionsForNodeKind = (
  nodeKind: string | null | undefined,
): { width: number; height: number } =>
  isGateNodeKind(nodeKind)
    ? { width: GATE_DIAMETER, height: GATE_DIAMETER }
    : { width: NODE_WIDTH, height: NODE_HEIGHT }
